import { render, staticRenderFns } from "./uploadabnormal-photo.vue?vue&type=template&id=6bfbd135&scoped=true"
import script from "./uploadabnormal-photo.vue?vue&type=script&lang=ts"
export * from "./uploadabnormal-photo.vue?vue&type=script&lang=ts"
import style0 from "./uploadabnormal-photo.vue?vue&type=style&index=0&id=6bfbd135&prod&lang=css"
import style1 from "./uploadabnormal-photo.vue?vue&type=style&index=1&id=6bfbd135&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfbd135",
  null
  
)

export default component.exports